import {
  FileWarning,
  ClipboardCheck,
  Bot,
  FileText,
  Search,
  CheckCircle,
  CalendarClock,
  ListChecks,
} from "lucide-react";
import type { ComponentType } from "react";

export type NotificationCategoryLabelKey =
  | "categories.document"
  | "categories.audit"
  | "categories.system"
  | "categories.finding"
  | "categories.update";

export type NotificationCategoryConfig = {
  color: string;
  bgColor: string;
  icon: ComponentType<{ size?: number; style?: React.CSSProperties }>;
  labelKey: NotificationCategoryLabelKey;
  /** Returns true if item should show urgency border (red-left-border) */
  isUrgent?: (metadata?: Record<string, string>) => boolean;
};

export const NOTIFICATION_CATEGORY_CONFIG: Record<
  string,
  NotificationCategoryConfig
> = {
  document_expiration: {
    color: "#f59e0b",
    bgColor: "rgba(245, 158, 11, 0.15)",
    icon: FileWarning,
    labelKey: "categories.document",
    isUrgent: (metadata) => Number(metadata?.daysRemaining ?? 99) <= 3,
  },
  audit_status_change: {
    color: "#E8734A",
    bgColor: "rgba(232, 115, 74, 0.15)",
    icon: ClipboardCheck,
    labelKey: "categories.audit",
  },
  audit_update: {
    color: "#E8734A",
    bgColor: "rgba(232, 115, 74, 0.15)",
    icon: ClipboardCheck,
    labelKey: "categories.audit",
  },
  system: {
    color: "#22c55e",
    bgColor: "rgba(34, 197, 94, 0.15)",
    icon: Bot,
    labelKey: "categories.system",
  },
  finding_created: {
    color: "#8b5cf6",
    bgColor: "rgba(139, 92, 246, 0.15)",
    icon: Search,
    labelKey: "categories.finding",
  },
  finding_resolved: {
    color: "#22c55e",
    bgColor: "rgba(34, 197, 94, 0.15)",
    icon: CheckCircle,
    labelKey: "categories.finding",
  },
  audit_deadline: {
    color: "#f97316",
    bgColor: "rgba(249, 115, 22, 0.15)",
    icon: CalendarClock,
    labelKey: "categories.audit",
    isUrgent: (metadata) => Number(metadata?.daysRemaining ?? 99) <= 1,
  },
  checklist_completed: {
    color: "#10b981",
    bgColor: "rgba(16, 185, 129, 0.15)",
    icon: ListChecks,
    labelKey: "categories.audit",
  },
};

export function getNotificationConfig(
  category: string,
): NotificationCategoryConfig {
  return (
    NOTIFICATION_CATEGORY_CONFIG[category] ?? {
      color: "#3b82f6",
      bgColor: "rgba(59, 130, 246, 0.15)",
      icon: FileText,
      labelKey: "categories.update",
    }
  );
}
